module.exports = __webpack_public_path__ + "img/ikon-en.0e8593cd.png";